import {HTMLProps} from 'react';
import HomeMenuV4 from './HomeMenuV4';
import ICON_LOGO_ON_LIGHT from '../../../../public/static/v4/home-header/icon-logo-light.svg';
import ICON_LOGO_OFF_LIGHT from '../../../../public/static/v4/home-header/icon-logo-off-light.svg';
import ICON_LOGO_OFF from '../../../../public/static/v4/home-header/icon-logo-off.svg';
import ICON_LOGO_ON from '../../../../public/static/v4/home-header/icon-logo.svg';
import useTheme from '../../../common/hook/useTheme';
import {ITheme} from '../../../common/type';
import MaxWidth from '../../../commonSub/component/MaxWidth';
import {HomeTabPage} from '../type';

interface IProps extends Omit<HTMLProps<HTMLDivElement>, 'onClick'> {
  currentTabPage: HomeTabPage;
  onClick: (tabPage: HomeTabPage) => void;
}

export default function HomeMenuListV4({
  currentTabPage,
  onClick,
  className,
  ...rest
}: IProps) {
  const {theme} = useTheme();
  return (
    <MaxWidth
      className={cn('flex items-center justify-center relative', className)}
      {...rest}
    >
      <div className="absolute bottom-0 inset-x-11 h-1 bg-grey-02 -z-1" />
      {[HomeTabPage.MyPage, HomeTabPage.Main, HomeTabPage.TimeTable].map(
        (tabPage, index) => {
          const isCurrentTab = tabPage === currentTabPage;
          const menu = HOME_MENU_MAP[tabPage];
          if (menu) {
            const {icon, textKey} = menu;
            return (
              <HomeMenuV4
                key={tabPage}
                src={icon && (isCurrentTab ? icon[theme].on : icon[theme].off)}
                textKey={textKey}
                className={cn(
                  isCurrentTab &&
                    'relative after:absolute after:bottom-0 after:h-2 after:bg-white light:after:bg-black after:w-full after:rounded-1',
                  textKey &&
                    (isCurrentTab
                      ? 's19-bold-white light:text-black'
                      : 's19-bold-grey05')
                )}
                onClick={() => onClick(tabPage)}
                index={index}
              />
            );
          }
        }
      )}
    </MaxWidth>
  );
}

const HOME_MENU_MAP: {
  [key in HomeTabPage]?: {
    icon?: Record<ITheme, {on: string; off: string}>;
    textKey?: string;
  };
} = {
  [HomeTabPage.Main]: {
    icon: {
      light: {
        on: ICON_LOGO_ON_LIGHT,
        off: ICON_LOGO_OFF_LIGHT,
      },
      dark: {
        on: ICON_LOGO_ON,
        off: ICON_LOGO_OFF,
      },
    },
  },
  [HomeTabPage.MyPage]: {
    textKey: 'common_tab_library',
  },
  [HomeTabPage.TimeTable]: {
    textKey: 'common_tab_time_table_global',
  },
};
